/*globals jQuery:false */
jQuery(document).ready(function () {
	const stickyNavs = document.querySelectorAll(".sticky-nav");

	/**
	 * add a class to position:sticky nav when it is in the stuck position
	 * otherwise position:sticky elements cannot have styles unique to stuck state
	 * see: https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
	 */
	const observerCallback = (entries) => {
		entries.forEach((entry) => {
			entry.target.classList.toggle("is-stuck", entry.intersectionRatio < 1);
		});
	};

	const observer = new IntersectionObserver(observerCallback, { threshold: [1] });

	stickyNavs.forEach((el) => {
		observer.observe(el);

		/**
		 * add a click handler to the first link in the nav to add class to open on mobile
		 * dependent on class sticky-nav--first-anchor-toggle
		 */
		/*if ( (' ' + el.className + ' ').indexOf(' sticky-nav--first-anchor-toggle ') > -1 ) {
			el.querySelector('a').addEventListener('click', evt => {
				evt.preventDefault();
				el.classList.toggle('is-open');
			});
		}*/

		/**
		 * add a click handler to the current menu item to add class to open menu on mobile
		 */
		el.querySelector("li.current--item a").addEventListener("click", (evt) => {
			evt.preventDefault();
			el.classList.toggle("is-open");
		});
	});

	/**
	 * Back To Top
	 */
	jQuery(".sticky-nav--back-to-top").click(() => jQuery(window).scrollTop());
});
